import { RATING_GRADIENTS } from '../constants/avatarConstants';

export const getAvatarGradient = (rating = 0) => {
  if (rating >= 1000) return RATING_GRADIENTS.elite;
  if (rating >= 500) return RATING_GRADIENTS.gold;
  if (rating >= 100) return RATING_GRADIENTS.silver;
  return RATING_GRADIENTS.default;
};

export const getDisplayName = (user) => {
  return user?.display_name || user?.username || 'Пользователь';
};